import { FormSetEnum } from '../../../types/src/services/enum/form-set.enum';

export const biKeys = [
    'hygiene',
    'eatDrink',
    'dressing',
    'showering',
    'toilet',
    'moving',
    'stairs',
    'walking',
    'stool',
    'urine',
];

export const deknKeys = [
    'abilityToCooperate',
    'age',
    'skinCondition',
    'otherIllnesses',
    'bodyCondition',
    'stateOfConsciousness',
    'activity',
    'mobility',
    'incontinence',
];

export const esasKeys = [
    'pain',
    'fatigue',
    'sleepiness',
    'nausea',
    'distaste',
    'shortnessOfBreath',
    'depression',
    'anxiety',
    'wellBeing',
    'other',
];

export const iadlKeys = [
    'phoning',
    'transport',
    'shopping',
    'cooking',
    'housework',
    'workAroundTheHouse',
    'medication',
    'finance',
];

export const msseKeys = [
    'restlessness',
    'shouts',
    'pain',
    'decubitus',
    'malnutrition',
    'eatingDisorders',
    'conflictBehavior',
    'unstableStateOfHealth',
    'sufferingAccordingToMedic',
    'sufferingAccordingToCaregiver',
];

export const niKeys = [
    'nightCalm',
    'communication',
    'memory',
    'contact',
    'behavior',
    'emotions',
    'consciousness',
    'problemSolving',
    'orientation',
    'perception',
];

export const ppsKeys = [
    'ppsValue',
];

export const ppsKeysExtra = [
    'mobility',
    'activity',
    'illnessSymptoms',
    'selfSufficiency',
    'foodIntake',
    'stateOfConsciousness',
];

export const rvdKeys = [
    'mobility',
    'activity',
    'incontinence',
    'bodyCondition',
    'mentalState',
];

export class FormsJsonKeys {

    public get(formSetType: string): string[] {
        switch(formSetType) {
            case FormSetEnum.BI:
                return biKeys;
            case FormSetEnum.DEKN:
                return deknKeys;
            case FormSetEnum.ESAS:
                return esasKeys;
            case FormSetEnum.IADL:
                return iadlKeys;
            case FormSetEnum.MSSE:
                return msseKeys;
            case FormSetEnum.NI:
                return niKeys;
            case FormSetEnum.PPS:
                return ppsKeys;
            case FormSetEnum.RVD:
                return rvdKeys;
            default:
                return [];
        }
    }
}
